module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CHAPTER 2")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("C")])]), _vm._v("ute.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Of all the things Princess Katherine of Wynborough had been called in her relatively uneventful life, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cute")]), _vm._v(" had not been one of them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Until now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("She followed Trey Sutherland down the stairs, down another endless hallway. If she were going to live here, she’d need to take a few hours and go exploring with a map. As far as she could figure, the house was shaped like a square U, with two long wings stretching back from the main building, forming the shelter for the center courtyard. The tower was on one front corner of the building—at the beginning of the opposite wing than the one they were heading down now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("In fact, if she looked out the window, across the courtyard and up, she could see the windows of Trey’s office, lights still blazing through the late-afternoon dreariness.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Trey slowed his pace and glanced at her. “I meant what I ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("said,” he told her. “Instead of coming to a definite decision after you meet the kids, you go home and think it over. Fax me your references, and tomorrow, if we still both think this will work—temporarily, of course—we’ll talk again.”")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("He was giving her an out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“This is the playroom,” he said, taking a deep breath before he opened the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Katherine wasn’t sure exactly what horror she’d expected to find, but the cheerful, brightly lit room, filled with books and games and toys, furnished with two big, overstuffed sofas and a small handful of rocking chairs wasn’t it. There was a huge fireplace. It was cold and dark now, but when lit it would be capable of warming nearly the entire large room. Windows and skylights let in what little light remained of the darkening afternoon. A cabinet was open, revealing a TV and VCR. A Disney tape was playing to the otherwise empty room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Trey strode to the VCR and turned both it and the TV off. He then went to an intercom system that was built into the wall. He leaned on one of the buttons, bent close to the microphone. “Stace. I thought I asked you to stay with Doug in the playroom this afternoon.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("A young girl’s voice came through the speaker, tinny and thin and clearly annoyed. “I was. But then he chewed through his leash….”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Chewed? Through his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("leash?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Trey didn’t look too happy about that, either. “How many times have I told you that if we treat him like a boy, he’ll act like a boy and…” He shook his head, clearly exasperated. “Just come down here,” he ordered. “There’s someone here I want you to meet.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Leash?” Katherine echoed weakly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Imaginary leash,” Trey said quickly. “I may not be father of the year, but I don’t tie my kids up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Doggie—Dougie—thinks he’s a dog.”")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("The girl’s room must have been right next door, because Stacy arrived in no time at all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("She stood in the doorway, arms across her chest. She was dressed entirely in black. Black leggings, black oversize turtleneck that hung down to her thighs, black lace-up boots with big clunky heels. Her short hair was black, too, although Katherine would have wagered she hadn’t been born with it that extreme color. She wore thick black eyeliner, an extremely pale shade of pancake base, an almost blackish red shade of lipstick, and black nail polish.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("The effect was…striking, but perhaps a little much for a thirteen-year-old.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“A "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dog")]), _vm._v(",” Katherine echoed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Yeah.” Stacy gazed at her, unsmiling, sullen to the point of near rudeness. “You know, arf, arf.” She turned to her father. “If you whistle for him, Trey, he’ll come.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Trey looked decidedly displeased, the muscles in the sides of his jaw jumping. “I’m not going to whistle for him because he’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" a dog.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Stacy turned to Katherine. “You must be nanny number 4,515.” The girl looked at her critically. “The suit’s cool, the knee-length skirt’s kind of retro, but you should lose the dorky blouse and just go with the jacket with nothing underneath—except maybe one of those black Miracle Bras from the Victoria’s Secret catalog. Trade in the nerd shoes for something with a three and a half inch heel and—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“And I don’t think so,” Trey interrupted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Yeah, you wouldn’t,” Stacy said with an exaggerated sigh. “You’re the one who hasn’t gone out with anyone but the awful Ice Queen in years—unless you’ve been getting busy on the sly with someone I don’t know about.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Oh, dear.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("For one awful moment, Trey Sutherland looked as if he were going to throttle his daughter. And then for one truly ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("dreadful moment, Katherine was afraid the man might cry. Then everything he was feeling, anger and hurt and embarrassment, was tucked neatly away. And when he spoke, his voice was devoid of all emotion.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“What did I do to deserve that?” he quietly asked his daughter.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Stacy knew perfectly well that she had completely overstepped the boundaries of propriety by saying such a thing in front of a stranger. She could apologize, or she could take the defensive route. As Katherine watched, the girl unwisely chose defensive. “It was just a joke. Lighten up, Trey.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Oh, dear. He clearly hated that she called him by his first name, and Stacy knew it. Katherine could see that the girl certainly had learned how to push her father’s buttons.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“If I’m nanny number 4,500 and something,” Katherine said, stepping boldly into the fray, “I can understand how this all might be a little overwhelming for the pair of you—and for Doug, too, poor thing. So why don’t we start again?” She looked at Trey. “Why don’t you give your son a break and whistle for him—obviously that’s what he wants you to do. And as for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v("—” she turned to Stacy “—let’s do this nicely, without embarrassing your father any further, shall we?” She held out her hand as Trey sighed and let out a piercing whistle. “I’m Kathy Wind. How do you do? Shake my hand and say ‘Fine, thanks.’”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Stacy’s fingers were cold and she had a grip about as firm as a fish. But her mouth twisted into what could almost be called a smile. “Fine, thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Excellent.” Katherine smiled, and squeezed the girl’s hand before letting go. “I think it’s important you’re in the information loop, so you need to know that your father’s only considering hiring me temporarily—until you and he and Doug can find someone that you’d like to hire for the long-term. I’ll be faxing my references and resume as soon as possible. I imagine you’ll want to look them over, too. If you have any questions you’d like to ask me then—or now, for that matter—please go right ahead.”")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Do you ride horses?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("A flash of movement near the farthest of the two sofas caught Katherine’s eye. Two very large brown eyes blinked at her and then quickly disappeared. Douglas had appeared. So to speak. Katherine looked back at Stacy. “Not well, I’m afraid. Do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“I hate horses. Is that hokey accent for real?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Trey closed his eyes. “Stacy—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“More real than your hair color,” Katherine pointed out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Doug was back, peering around the back of the sofa, and this time, Katherine didn’t look directly at him. She simply let him look at her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Stacy leaned against the wall, feigning disinterest, but there was a definite spark in her brown eyes. “Don’t you like my hair this way?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Katherine didn’t hesitate. “The style? Yes. The color, sorry, no. However, it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" your hair and you have the right to dye it whatever color you like.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("It was the right answer, Katherine noted, because Stacy had to work to prevent her approval from leaking past her facade of boredom. “Do you have any tattoos?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Good heavens. “No, I’m tattoo free—and completely un-pierced as well.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Not even your ears?” The girl was actually remarkably pretty, with a heart-shaped face that—even through the last layers of baby fat—boasted a pair of dramatic cheekbones that were quite a bit like her handsome father’s.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("And from what Katherine could see of Doug in her peripheral vision, he looked quite a bit like his sister. Same delicately shaped face. Significantly lighter shade of brown hair, though.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Not even my ears,” she told Stacy cheerfully.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“You’re kidding. Are you a virgin, too?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("“Anastacia.” Trey bristled, his beautiful mouth set in a grim line. “The idea was that you could ask Kathy questions pertain")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("ing to her employment here. If you’d rather go to your room, just keep it up.” He strode tensely toward the hallway. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Where")]), _vm._v(" is Douglas?”")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“I imagine he’ll come out when he’s ready.” Katherine looked at the little boy and smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("He didn’t smile back, but this time at least he didn’t retreat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“I understand you play the clarinet.” Katherine moved to the couch and sat, and, as if Doug really were a dog, she casually draped her hand over the arm rest, down close to him, as if for him to sniff. “I used to play the oboe.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“The oboe? Man, double reeds are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("really")]), _vm._v(" hard to—” Stacy cleared her throat, uncomfortable, it seemed, that she’d actually almost been enthusiastic.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Out of all her sisters, Katherine was the only one who had glided almost quietly through her early teens. And although she’d mostly kept her mood swings to herself, preferring to hide away in her room with a good book, she’d lived through all three of her sisters’ significantly noisier bouts of thirteen-year-old angst.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“How about you, sir?” Katherine asked Stacy’s father. “Are you at all musical?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“You’ve really got to stop calling me that.” He turned to look at her, his blue eyes just as shuttered as Stacy’s brown ones. This was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quite")]), _vm._v(" a family. Of course, she should talk. The Wyndhams weren’t known for their lack of repression, and out of all the princesses, Katherine was perhaps most guilty of keeping her true feelings under wraps.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Trey used to play the piano, but these days he only plays the stock market,” Stacy said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Sir,” Trey said, sidestepping Stacy’s last remark. “It makes me feel like some medieval lord of the manor.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("He spotted his son, who had gotten close enough to breathe on Katherine’s hand, but not close enough to touch. “There you are.” Several long strides brought him next to the sofa, and he ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("leaned over, scooping Doug up and into his arms. “Doug, this is Kathy Wind. Kathy, this is…”")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("The boy was dreadfully, painfully shy, and he clung to Trey, burying his face in the man’s shoulder. “Douglas,” Trey finished somewhat apologetically. “Well, it’s the back of Doug’s head, anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("He embraced the boy tightly, resting his cheek against the small tousled head for a long moment. “Come on, Dougie. Don’t you want to meet Kathy?” he asked quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Doug shook his head no.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“It’s all right,” Katherine said. “We both got a chance to look each other over. He looks all right to me, and as long as I look all right to him, and to Stacy, as well—” she turned to the girl “—I think we’ll get along all right. What do "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" think?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Stacy shrugged. “I guess.” She looked at her father. “Can I, like, go now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Trey glanced at Katherine, and nodded. “Yeah,” he said. “Sure.” He let Doug slide down to the floor as well, and the two children were gone from the room in a flash.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Katherine would have risen to her feet, but Trey sat down on the other end of the sofa as if he were exhausted, as if every bone in his body had turned to liquid. He stretched his long legs out in front of him, his head against the back cushions, as he stared up at the slightly vaulted ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“So,” he said with a laugh that didn’t have much to do with humor. “There we are. In all our dysfunctional glory.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("He turned his head to look at her, and was unable to hide a glint of despair in his eyes. “I’m not very good at this parenting thing,” he admitted. His smile was self-deprecating. “I guess that was pretty obvious.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Katherine chewed thoughtfully on her lower lip. “What was obvious was that you love them. They certainly are—” she couldn’t keep from smiling “—unique.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("His smile became much more genuine. “Understatement.” ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("He stood up and she, too, rose to her feet. “I appreciate your spending all this time here this afternoon, Kathy. I won’t keep you any longer.”")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Kathy. Her sisters had sometimes called her Kathy, but no one else ever had. She’d always, always been Princess Katherine. It was funny, actually, hearing her childhood nickname on a man’s lips.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("On this man’s very attractive lips.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("His very maleness seemed to linger about him, never far from the surface. Even now, as he gazed at her, there was something in his eyes that wouldn’t let her forget that he was a man, and she was a woman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Katherine wanted him to hire her as a temporary nanny because she wanted to locate one Mr. William Lewis. She also wanted to help Trey Sutherland out of this bind he was in. And, yes, she had to be completely honest here. She liked being looked at and spoken to as if she were a normal woman. Not a princess to bow and scrape and be obsequiously polite to at all times.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“I’ll get those references to you as quickly as I can,” she told him. “By tonight, if possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Tomorrow will be fine.” He started toward the door. “If and when you decide that—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Oh, I’ve decided.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“I meant what I said about you taking the time to think it over.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“I don’t need time,” she told him. “I’ll fax them to you tonight. I want this job, and if, as you’ve led me to believe, you’re desperate, well, then…If my references meet your approval—and I believe they will—I see no reason why I shouldn’t start tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("“It’s perfect, Laura,” Katherine said into her cellular phone as she drove back into Albuquerque. “If William Lewis shows up, I’ll be there. Already inside the gates of the Sutherland estate.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“As the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nanny")]), _vm._v(".” Laura Bishop was both Royal Social Secretary and friend. Currently she was an extremely skeptical friend.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“I’d really just be a glorified baby-sitter,” Katherine explained. “And "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that’s")]), _vm._v(" perfect, too. After I drive the children to school in the morning, I’ll have nearly the entire day to try to find out where Bill Lewis has gone. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Someone")]), _vm._v(" in Albuquerque knows where he is, I know it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“And you want me to, what? Make some fake references for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Not fake references.” Katherine pulled into the parking lot of a shopping mall to consult her street map. She had the most dreadful sense of direction of anyone in the world. She searched for the avenue she had just been on, craning her neck to check the name of the cross street. “Real references. Let Alexandra be one. A princess of Wynborough as a reference—that ought to make something of an impact. And I know you could talk Dr. McMahon into vouching for Kathy Wind’s character, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Laura sighed. “Katherine, this could be a complete wild-goose chase. We don’t even know if Bill Lewis is our man.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“We don’t know that he’s not.” Katherine found the avenue, found the cross street and…yes, she’d been heading "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("away")]), _vm._v(" from the hotel. Drat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“You know, this place has been in something of an uproar since you left this morning,” Laura told her, referring to the royal vacation home back in Aspen. “Gabriel Morgan’s been positively grim about the fact that you just flew off to New Mexico without arranging any kind of a game plan with him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Oh, shoot.” Katherine cringed. Gabe Morgan was in charge of the royal bodyguards. “It’s just…I called Trey Sutherland’s office this morning and was told I could see him at three. I just grabbed the first plane reservation I could get. I didn’t have time to do more than leave a note on your desk.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Which I found only about an hour ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Oh dear, I’m so sorry!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("“I was just glad it was you. If it were Serena who’d gone ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("missing that way, I think Gabe might’ve had an aneurism on the spot.”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Laura, it’s going to look extremely peculiar if the new nanny shows up with a bodyguard, so—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Laura sighed again. “I’ll take care of that, too. Just…promise me you’ll be careful.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Of course, I’ll be careful. And, oh, as far as the references go, I’ve been completely honest with Trey—except about my name. I’ve simply neglected to tell him I’m a princess,” Katherine said. “He knows I’ve had no previous experience as a nanny. But the children aren’t infants, so…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Trey")]), _vm._v(", huh? This is getting more and more interesting. Maybe I should reconsider the bodyguard thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Katherine felt herself blush. “No,” she said. “It’s not…I don’t…he doesn’t…he thinks I’m a nanny, and, I mean…” She took a deep breath. “Don’t go there, Laura. He’s simply very informal. Casual. He told me he expects me to wear blue jeans to work.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Trey had told her to dress casually, adding that he thought she looked to be a blue jeans and T-shirt type. Katherine had been thrilled he would think that, thrilled to be thought of as someone who didn’t necessarily have to wear a tiara to tea. She couldn’t remember the last time she’d worn something as casual as blue jeans. She didn’t even have a pair in her wardrobe. That was going to change this afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Let me have Sutherland’s fax number again,” Laura said. “And, Katherine? I know I don’t really have to tell you this again, but…please be careful.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("“Thursday night,” Trey’s mother said. “At the country club. Have you written it into your calendar? I’ll hold on while you check.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("Trey closed his eyes. “Mom. I’ll be there.” Damn Bill, anyway. This was all his fault. Whenever Sutherland-Lewis ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("needed to be represented at a high society function here in town—or in Los Angeles or New York, for that matter—Bill Lewis did the honors. Leaving Trey with his computers and his deadlines, blessedly far from the limelight and the curious stares that always followed him around.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Did he or did he not kill his wife? Even after three very long years, the rumors persisted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("And the irony of those rumors would have been hysterically funny, except that Helena’s death still hurt far too much for him to even "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("think")]), _vm._v(" about laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("And as far as the rumors went, Trey hadn’t done "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("completely")]), _vm._v(" all that he could to squash them once and for all. No, after that woman’s magazine had chosen him as “eligible bachelor of the month,” he’d actually been grateful when the dark rumors had resurfaced, and the flock of gold diggers pursuing him had vanished.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Vanished as surely as Kathy Wind had when she’d left the estate late this afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Trey stared at his fax machine, willing it to click on. But it was silent. It was nearly eight-thirty in the evening, and he still hadn’t received Kathy Wind’s references.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“I’ll have my driver pick up Diana,” Penelope Sutherland decided. “We’ll stop at your place at seven for a small glass of wine before heading over to the club. Tell your housekeeper to dress for the occasion, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Trey sighed. “Anita will already have gone home for the night.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“What kind of housekeeper leaves when you need her most?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“The kind with a family of her own. And I don’t think answering the door and pouring wine qualifies for ‘needing her most.’”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“I don’t know why you put up with her—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("“Mother, don’t.” Trey cut her off before she started in on lecture number 612 on “Reasons to Hire a New Housekeeper.” Penelope didn’t like Anita, couldn’t understand that Trey "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("liked")]), _vm._v(" the fact that the friendly, vivacious Mexican-American woman dressed and acted so casually. Trey’s mother didn’t get it. She didn’t under")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("stand that he didn’t want to live in a mausoleum filled with silently grim servants who bowed and scraped and kowtowed. He’d had enough of that when he was growing up, thanks.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("It was dark outside, and the window reflected his blurred image. Poor little rich boy. He turned back to his desk, to stare at his fax machine, which was still silent, damn it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Thursday at seven,” he said. “It’s in my book.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“You should call Diana to confirm.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You’re")]), _vm._v(" picking her up,” Trey countered. “"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You")]), _vm._v(" call Diana.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Penelope sighed. “If you don’t call her, it’s not going to be a real date.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Guess what, Mom? It’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" a real date.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("“Trey, you know how much I loved Helena.” Penelope Sutherland "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" loved Trey’s wife like a daughter. She’d been best friends with Helena’s mother since grade school. “But enough is enough. It’s time to move ahead with your life. Time to have some fun again.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Fun? With Diana St. Vincent? “Yeah, look, Mother, I’ve got to go. I’ll see you Thursday, all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Trey rolled his eyes as he hung up the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Diana St. Vincent, the heir to the James Company fortune, was smart, she had an unerring fashion sense, she was socially connected, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and")]), _vm._v(" she was loaded. But she was also cold as hell. Trey had known her for several years, but he still couldn’t even imagine what she did for fun.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Unless, of course, his mother was talking in vaguely polite euphemisms, and by fun what she really meant was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sex")]), _vm._v(". It was time for Trey to have some sex again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("And yes indeed, after three years, there certainly were times, every now and then, when Trey could imagine maybe, just maybe, having sex again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Oh, yeah.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("That")]), _vm._v(" was quite possibly the biggest understatement of the decade.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("And tonight—God help him—was one of those nights when ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("his imagination was running wild and he couldn’t seem to stop thinking about sex.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("And not the pleasant, politely proper sex he’d shared with Helena during their eleven and a half years of marriage. He’d loved his wife, but when they’d made love, he’d always, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("always")]), _vm._v(" held himself back. She was so well-bred, so gentle and refined. He’d always been afraid he might shock her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("No, tonight he couldn’t stop thinking about raw, ragingly passionate, heart-stoppingly, gut-wrenchingly, completely insane sex. The kind where it’s almost like an out-of-body experience because you can’t tell where you end and your lover begins. The kind where you lose yourself in the sheer potent ecstasy of a single kiss and—")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Trey opened his eyes, suddenly astutely aware that the fantasy lover he’d just been imagining in his bed was none other than the candidate for the position of temporary nanny, Kathy Wind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Oh God, where had "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" thought come from?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Kathy was pretty enough, and sure, she had a body that would probably cause a small sensation if she wore a bikini onto a beach. But that woman probably didn’t even "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("own")]), _vm._v(" a bikini. She seemed far, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("far")]), _vm._v(" from the raw, screaming sex type.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("She was warm cocoa and cookies, soft and sweet, wrapped in a fleece blanket in front of a crackling fire.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("She was little-sister material, while Diana St. Vincent…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("It "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" likely that beneath Diana’s cool facade burned searing passion.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("She was a beautiful woman. Thick black hair, porcelain perfect features, a body to die for and the ability to show it off in a very classy way. Diana St. Vincent probably owned a dozen bikinis. And she’d made it clear that Trey’s advances would be more than welcomed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("But he knew that any intimacies he shared with her would have a very steep price. Marriage.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("And the thought of marrying Diana St. Vincent left Trey stone-cold.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("She didn’t care about him. Not one bit. Like all of the others—even like Helena—she couldn’t see past his bank account to the man beneath.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("And he wasn’t going to do "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" again. He’d rather spend the rest of his life alone than be conned that way again. And alone was most likely the way he’d remain because most people—both men and women—couldn’t get past his huge fortune. They were either completely intimidated and stayed away, or they wanted a piece of it, and were willing to do anything to get it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("What were the chances of his ever finding a woman who said, “The hell with your money. Burn it for all I care. All I want is Trey the man.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("No, all the women he’d ever met had been far more in love with Trey-the-wallet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("It wasn’t too hard to understand why. It wasn’t as if he were a warm, friendly, open, expressive person.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("In fact, many, many people had labeled him icy cold, both socially and at work. Especially at work.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("The truth was, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" wouldn’t want to work for himself. And he wouldn’t blame Kathy Wind at all if she simply never faxed her references—if she turned and ran, and he simply never heard from her again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("That would be a damn shame. Stacy had liked her. Stacy had actually stopped into his office about an hour ago to find out if Kathy’s references had checked out. Dear God, was that a miracle? The idea that Stacy might actually "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("like")]), _vm._v(" her nanny…?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Except Kathy wasn’t their nanny yet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Trey closed his eyes, praying to whomever might be out there listening. Please, please, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("please")]), _vm._v(" don’t let Kathy change her mind. If Stacy liked her, Doug would like her, too. His children desperately needed someone with such a warm, sweet, completely sincere demeanor in their lives.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("They needed cocoa in front of the fire.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("And as for Trey…He’d keep his thoughts pure from now on, at least when it came to Kathy Wind. It was absurd, really, what he’d been thinking. But he could explain it easily enough. He was tired and obsessing over the fact that he wanted her to fax her references, that he wanted her for this job.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Somehow all his various wants and needs had gotten cross-wired. That was all. No big deal.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("With her direct honesty and appealing sincerity, Kathy would fit right in. She would become the little sister he’d never had.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("The fax machine turned on with a whir and a mechanical burp, and Trey sat up. He crossed the room and…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Yes")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("Kathy Wind’s references.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("There "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" a god.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c867064","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/undercoverprincess_ch02.vue
// module id = 69
// module chunks = 0